import en from './assets/locales/en.json'

export default {
  locale: 'en',
  messages: {
    en: en,
  }
}